import { MEMBER_JOIN_STATUS } from '@/api';
import { useAuthStore } from '@/stores/AuthStore';
export const useIsNewUser = () => {
  const isNewUser = useAuthStore(_temp);
  return isNewUser;
};
function _temp(t0) {
  const {
    myInfo
  } = t0;
  const memberJoinStatus = myInfo?.memberJoinStatus;
  return memberJoinStatus ? [MEMBER_JOIN_STATUS.NO_PHONE, MEMBER_JOIN_STATUS.NO_NICKNAME].includes(memberJoinStatus) : false;
}